module.exports = __webpack_public_path__ + "img/pr-3.de8b2cee.png";